/**
 * DevExtreme (esm/ui/data_grid/ui.data_grid.error_handling.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import gridCore from "./ui.data_grid.core";
import {
    errorHandlingModule
} from "../grid_core/ui.grid_core.error_handling";
gridCore.registerModule("errorHandling", errorHandlingModule);
